import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-viewThree',
  templateUrl: './viewThree.component.html',
  styleUrls: ['./viewThree.component.css']
})
export class ViewThreeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
